import apiInstance from "@services/Shared/instanceAxios";

const deleteMediaVideo = (mediaId: string) =>
  apiInstance({
    url: `/media/${mediaId}/video`,
    method: "delete",
  });

export default deleteMediaVideo;
